export const FEATURES = {
  BLOG: 'BLOG',
  MEDICAL_RECORDS: 'MEDICAL_RECORDS',
  MEDICATION: 'MEDICATION',
  SHOP: 'SHOP',
  EMERGENCY_CALL: 'EMERGENCY_CALL',
  HEALTH_MONITOR: 'HEALTH_MONITOR',
  ALERTS: 'ALERTS',
  DAILY_CHECKIN: 'DAILY_CHECKIN',
  AI_CHAT: 'AI_CHAT',
  AI_ENGINE: 'AI_ENGINE',
  AI_NUTRITION: 'AI_NUTRITION',
};

export const FEATURE_LABELS = {
  BLOG: 'Bài viết',
  MEDICAL_RECORDS: 'Hồ sơ khám bệnh',
  MEDICATION: 'Lịch uống thuốc',
  SHOP: 'Cửa hàng',
  EMERGENCY_CALL: 'Gọi khẩn cấp',
  HEALTH_MONITOR: 'Theo dõi chỉ số sức khỏe',
  ALERTS: 'Thông báo & cảnh báo',
  DAILY_CHECKIN: 'Điểm danh sinh tồn',
  AI_CHAT: 'Trợ lý AI',
  AI_ENGINE: 'AI rủi ro & gợi ý',
  AI_NUTRITION: 'AI tư vấn dinh dưỡng',
};

/** Miễn phí — không cần gói Pro */
export const FREE_FEATURES = [
  FEATURES.BLOG,
  FEATURES.MEDICAL_RECORDS,
  FEATURES.SHOP,
];

/** Cần gói Pro (119k/tháng) */
export const PRO_FEATURES = [
  FEATURES.MEDICATION,
  FEATURES.EMERGENCY_CALL,
  FEATURES.HEALTH_MONITOR,
  FEATURES.ALERTS,
  FEATURES.DAILY_CHECKIN,
  FEATURES.AI_CHAT,
  FEATURES.AI_ENGINE,
  FEATURES.AI_NUTRITION,
];

/** @deprecated */
export const BASIC_FEATURES = PRO_FEATURES;
/** @deprecated */
export const PREMIUM_FEATURES = PRO_FEATURES;

export function hasFeature(access, featureKey) {
  return Boolean(access?.features?.[featureKey]);
}
